import { http, HttpResponse } from 'msw';
import { PlessService } from '../../../app/shared/pless-service.model';
import { ResponseUtils } from '../response-utils';

export const kymw1700Handlers = [

  // 画像ファイル一覧取得要求
  http.post(PlessService.SERVICE.KYMW17GetImageInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(KYMW17GetImageInfoResponse);
    // return HttpResponse.json(KYMW17GetImageInfoResponseNull);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // サンプル発注書・撮影指示書PDF出力項目取得
  http.post(PlessService.SERVICE.KYMW17GetSampleOrderingOutput.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(KYMW17GetSampleOrderingOutputResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 撮影指示書PDF出力項目取得
  http.post(PlessService.SERVICE.KYMW17GetOrderingOutput.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(KYMW17GetSampleOrderingOutputResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 撮影リストエクセル出力項目取得
  http.post(PlessService.SERVICE.KYMW17GetPhotoContentsListOutput.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(KYMW17GetSampleOrderingOutputResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 参考資料ファイル情報取得
  http.post(PlessService.SERVICE.KYMW17GetReferenceImageOutput.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(KYMW17GetSampleOrderingOutputResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 画像情報管理更新
  http.post(PlessService.SERVICE.KYMW17UpdateImageInfo.url, async ({ request }) => {
    const req = await request.json();
    return HttpResponse.json(KYMW17UpdateImageInfoResponse);
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // C2PFステータス更新
  http.post(PlessService.SERVICE.KYMW17UpdateC2pfStatus.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),

  // 画像種類同期
  http.post(PlessService.SERVICE.KYMW17UpdateImageKind.url, async ({ request }) => {
    const req = await request.json();
    return ResponseUtils.getSuccess();
    // return ResponseUtils.getSysError();
    // return ResponseUtils.getE0100();
    // return ResponseUtils.get500();
  }),
];

const KYMW17GetImageInfoResponseNull = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      PublishImageData: []
    }
  }
}

const KYMW17GetImageInfoResponse = {
  "status": "ok",
  "message": "処理完了",
  "result": {
    "obj": {
      "PublishImageData": [
        {
          "ImageFileName": "P2541684B_07",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "太陽のタマゴ（完熟マンゴー・ｅフレンズ限定）",
          "GuideStandardName": "１箱（２玉入）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023160",
          "DelivCatalogId": "20230701",
          "ImageId": "671347",
          "Enabled": "0",
          "ImageName": "P2541684B",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "4",
          "ImageUseMethodName": "過去画像使用",   // 過去画像登録画面表示可能
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "1",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "器:丸皿,皿の色変更（基本はグリーン）:白,盛り方:山高盛り,添え物:青み添え",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "8",                    // 過去画像登録画面表示可能
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "２０２３年５月２３日撮影",
          "PhotoSchedule": "20230523",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230524",
          "ImageInstructUserId": "iidak3  ",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230607 13:07:22",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000032618",
          "ImageGroupNo": "575220",
          "SmallClass": "マンゴー",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2541684"
        },
        {
          "ImageFileName": "P2599669C_21",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1134822-M2QX548O-M2QX548O",
          "GuideGoodsName": "赤ちゃん用　うどんスープ（粉末つゆの素）",
          "GuideStandardName": "２．２ｇ×８袋入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023160",
          "DelivCatalogId": "20230701",
          "ImageId": "675198",
          "Enabled": "0",
          "ImageName": "P2599669C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "2",
          "ImageUseMethodName": "Mdb画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "8",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230616",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230614",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230627 19:25:15",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902475212208",
          "ImageGroupNo": "577486",
          "SmallClass": "フリーズドライＢＦ",
          "BuyerCode": "00600019",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2599669"
        },
        {
          "ImageFileName": "P2599669C_22",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1134822-M2QX548O-M2QX548O",
          "GuideGoodsName": "赤ちゃん用　うどんスープ（粉末つゆの素）",
          "GuideStandardName": "２．２ｇ×８袋入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023160",
          "DelivCatalogId": "20230701",
          "ImageId": "675199",
          "Enabled": "0",
          "ImageName": "P2599669C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "3",
          "ImageUseMethodName": "自社画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "1",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230616",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230614",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230627 19:25:16",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902475212208",
          "ImageGroupNo": "577486",
          "SmallClass": "フリーズドライＢＦ",
          "BuyerCode": "00600019",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2599669"
        },
        {
          "ImageFileName": "P2599669C_23",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1134822-M2QX548O-M2QX548O",
          "GuideGoodsName": "赤ちゃん用　うどんスープ（粉末つゆの素）",
          "GuideStandardName": "２．２ｇ×８袋入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023160",
          "DelivCatalogId": "20230701",
          "ImageId": "675200",
          "Enabled": "0",
          "ImageName": "P2599669C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "4",
          "ImageUseMethodName": "過去画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "1",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230616",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230614",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230627 19:25:16",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902475212208",
          "ImageGroupNo": "577486",
          "SmallClass": "フリーズドライＢＦ",
          "BuyerCode": "00600019",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2599669"
        },
        {
          "ImageFileName": "P2670365F_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E6969243-LVGZ731H-N5LN6TVU",
          "GuideGoodsName": "やくみ処　わさび風味",
          "GuideStandardName": "３２ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023160",
          "DelivCatalogId": "20230701",
          "ImageId": "666715",
          "Enabled": "0",
          "ImageName": "P2670365F",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "4",
          "ImageUseMethodName": "過去画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "1",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "1",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230418",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230412",
          "ImageInstructUserId": "nomurat8",
          "ImageInstructUser": "",
          "BuyerName": "長谷川桂",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230518 11:29:10",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4902820119909",
          "ImageGroupNo": "575079",
          "SmallClass": "その他",
          "BuyerCode": "00600018",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2670365"
        },
        {
          "ImageFileName": "P2534358E_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "フローズンヨーグルト",
          "GuideStandardName": "１０５ｍｌ×３個",
          "PhotoContentsName": "",
          "StartOrderCode": "2023160",
          "DelivCatalogId": "20230701",
          "ImageId": "668992",
          "Enabled": "0",
          "ImageName": "P2534358E",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "1",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "切抜or角版:角版（背景あり）",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "2",
          "DelayFlag": "",
          "SupplierAnnouncement": "取引先への連絡事項",
          "SupplierInfo": "取引先コメント",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230427",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230501",
          "ImageInstructUserId": "ushijimh",
          "ImageInstructUser": "",
          "BuyerName": "酒井",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230607 13:47:21",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4902220479092",
          "ImageGroupNo": "573918",
          "SmallClass": "マルチ",
          "BuyerCode": "00800001",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2534358"
        },
        {
          "ImageFileName": "P2597190C_08",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00102575-00080000",
          "GuideGoodsName": "北海道の野菜ミックスたまねぎ入り",
          "GuideStandardName": "２５０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023160",
          "DelivCatalogId": "20230701",
          "ImageId": "675203",
          "Enabled": "0",
          "ImageName": "P2597190C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "2",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230616",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230614",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "海邊麻夕子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:46",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220006960",
          "ImageGroupNo": "577489",
          "SmallClass": "その他",
          "BuyerCode": "00500009",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2597190"
        },
        {
          "ImageFileName": "P2507640C_08",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "じゃがいも（とうや）",
          "GuideStandardName": "１．２ｋｇ（サイズ込）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "670554",
          "Enabled": "0",
          "ImageName": "P2507640C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230515",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230515",
          "ImageInstructUserId": "fujimatr",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230614 17:18:00",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000008736",
          "ImageGroupNo": "574866",
          "SmallClass": "ジャガイモ",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2507640"
        },
        {
          "ImageFileName": "P2566939C_15",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00115475-00010000",
          "GuideGoodsName": "極深煎焙煎有機栽培アラビカ１００％アイスコーヒー",
          "GuideStandardName": "１０００ｍｌ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "671067",
          "Enabled": "0",
          "ImageName": "P2566939C",
          "ClassCode": "04",
          "ClassName": "日配",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "1",
          "ImageUseMethodName": "撮影",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "01",
          "TempRangeName": "冷蔵",
          "MultipleCode": "gazouFileName1,gazouFileName2                      ",
          "PastImageInfo": "過去画像情報サンプル",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "1",
          "DelayFlag": "0",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "",
          "Remarks": "ヴィ・ナチュール２０２３．７－２表紙",
          "PhotoSchedule": "20230518",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230522",
          "ImageInstructUserId": "ushijimh",
          "ImageInstructUser": "",
          "BuyerName": "安倍智勇",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230615 18:01:50",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4902220241200",
          "ImageGroupNo": "575190",
          "SmallClass": "嗜好飲料",
          "BuyerCode": "00500021",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2566939"
        },
        {
          "ImageFileName": "P2604031C_05",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E2248650-M6EH1CM5-M6EH1CM5",
          "GuideGoodsName": "ブルガリアヨーグルトＬＢ８１プレーン",
          "GuideStandardName": "４００ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "670500",
          "Enabled": "0",
          "ImageName": "P2604031C",
          "ClassCode": "04",
          "ClassName": "日配",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "01",
          "TempRangeName": "冷蔵",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "明治（飲料デザート）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230516",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230512",
          "ImageInstructUserId": "yamaurm2",
          "ImageInstructUser": "",
          "BuyerName": "安倍智勇",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:49",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4902705011625",
          "ImageGroupNo": "574834",
          "SmallClass": "プレーンヨーグルト",
          "BuyerCode": "00500021",
          "BillingCode": "920576",
          "SampleOrderingCode": "920576",
          "SampleOrderingName": "明治（飲料デザート）",
          "SupplierSalesStaffName": "",
          "PCode": "P2604031"
        },
        {
          "ImageFileName": "P2618657C_03",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E5829524-MDDY21QR-MDDY21QR",
          "GuideGoodsName": "ぴょんぴょん舎　盛岡冷麺（生）",
          "GuideStandardName": "２食セット",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "667391",
          "Enabled": "0",
          "ImageName": "P2618657C",
          "ClassCode": "04",
          "ClassName": "日配",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "01",
          "TempRangeName": "冷蔵",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "岩手県産株式会社（特殊日配）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230512",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230419",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "古川和宏",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230614 17:18:15",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4517870003025",
          "ImageGroupNo": "572985",
          "SmallClass": "冷し中華",
          "BuyerCode": "00500026",
          "BillingCode": "967653",
          "SampleOrderingCode": "967653",
          "SampleOrderingName": "岩手県産株式会社（特殊日配）",
          "SupplierSalesStaffName": "",
          "PCode": "P2618657"
        },
        {
          "ImageFileName": "P2602515C_08",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00006349-00090000",
          "GuideGoodsName": "杏仁豆腐の素（ソフトタイプ）　シロップ付",
          "GuideStandardName": "７０ｇ×２袋",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "676450",
          "Enabled": "0",
          "ImageName": "P2602515C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230623",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230621",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:47",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220025602",
          "ImageGroupNo": "578148",
          "SmallClass": "デザート",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2602515"
        },
        {
          "ImageFileName": "P2670165C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E9712781-N5KE3HH8-N5KE3HH8",
          "GuideGoodsName": "内池漬けじょうず（ピリ辛味）",
          "GuideStandardName": "２００ｍｌ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "667234",
          "Enabled": "0",
          "ImageName": "P2670165C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コパロン（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230418",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230418",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤岳",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230614 17:19:14",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4970964016118",
          "ImageGroupNo": "572868",
          "SmallClass": "和風調味料２ぐる",
          "BuyerCode": "00600010",
          "BillingCode": "954942",
          "SampleOrderingCode": "954942",
          "SampleOrderingName": "コパロン（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2670165"
        },
        {
          "ImageFileName": "P2603723C_32",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1371195-M6GF4U9R-M6GF4U9R",
          "GuideGoodsName": "野菜ピューレにんじん",
          "GuideStandardName": "２４０ｇ（３０ｇ×８袋）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "676446",
          "Enabled": "0",
          "ImageName": "P2603723C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "東京コールドチェーン（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230623",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230621",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:48",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4938545402378",
          "ImageGroupNo": "578146",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "946788",
          "SampleOrderingCode": "946788",
          "SampleOrderingName": "東京コールドチェーン（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2603723"
        },
        {
          "ImageFileName": "P2603723C_33",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1371195-M6GF4U9R-M6GF4U9R",
          "GuideGoodsName": "野菜ピューレにんじん",
          "GuideStandardName": "２４０ｇ（３０ｇ×８袋）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "676447",
          "Enabled": "0",
          "ImageName": "P2603723C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "東京コールドチェーン（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230623",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230621",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:48",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4938545402378",
          "ImageGroupNo": "578146",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "946788",
          "SampleOrderingCode": "946788",
          "SampleOrderingName": "東京コールドチェーン（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2603723"
        },
        {
          "ImageFileName": "P2603723C_34",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1371195-M6GF4U9R-M6GF4U9R",
          "GuideGoodsName": "野菜ピューレにんじん",
          "GuideStandardName": "２４０ｇ（３０ｇ×８袋）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023170",
          "DelivCatalogId": "20230702",
          "ImageId": "676448",
          "Enabled": "0",
          "ImageName": "P2603723C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "東京コールドチェーン（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230623",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230621",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:49",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4938545402378",
          "ImageGroupNo": "578146",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "946788",
          "SampleOrderingCode": "946788",
          "SampleOrderingName": "東京コールドチェーン（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2603723"
        },
        {
          "ImageFileName": "P2658110C_10",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "S1552995-MYUC9FYX-MYUC9FYX",
          "GuideGoodsName": "シーフードミックス",
          "GuideStandardName": "２００ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023180",
          "DelivCatalogId": "20230703",
          "ImageId": "677419",
          "Enabled": "0",
          "ImageName": "P2658110C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "マルハニチロ（無店舗水産）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230630",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230628",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "谷口",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230707 11:58:46",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4901901632634",
          "ImageGroupNo": "578662",
          "SmallClass": "ミックス",
          "BuyerCode": "00200002",
          "BillingCode": "971863",
          "SampleOrderingCode": "971863",
          "SampleOrderingName": "マルハニチロ（無店舗水産）",
          "SupplierSalesStaffName": "",
          "PCode": "P2658110"
        },
        {
          "ImageFileName": "P2668523C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1252610-N4NN3XQS-N4NN3XQS",
          "GuideGoodsName": "豚ロース肉の黒胡椒揚げ",
          "GuideStandardName": "２０５ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023180",
          "DelivCatalogId": "20230703",
          "ImageId": "660447",
          "Enabled": "0",
          "ImageName": "P2668523C",
          "ClassCode": "03",
          "ClassName": "畜産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "ホーム食品（クルコ用）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230307",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230227",
          "ImageInstructUserId": "nishiym9",
          "ImageInstructUser": "",
          "BuyerName": "にいがた地域",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230621 16:49:26",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4907653126179",
          "ImageGroupNo": "568679",
          "SmallClass": "カナダ豚",
          "BuyerCode": "00800005",
          "BillingCode": "976997",
          "SampleOrderingCode": "976997",
          "SampleOrderingName": "ホーム食品（クルコ用）",
          "SupplierSalesStaffName": "",
          "PCode": "P2668523"
        },
        {
          "ImageFileName": "P2564332C_03",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E6299477-LLCH0WP5-LLCH0WP5",
          "GuideGoodsName": "ドライアプリコット　コラーゲン入り",
          "GuideStandardName": "６５ｇ（個包装紙込み）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023190",
          "DelivCatalogId": "20230704",
          "ImageId": "675083",
          "Enabled": "0",
          "ImageName": "P2564332C",
          "ClassCode": "05",
          "ClassName": "菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "1",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "数量:全量,数量／個数:3,数量／器数:4,器形状:鉢(深皿),器:ガラス,イメージ:涼しさ,断面:1個カットして中見せ,撮影演出:湯気出し",
          "ReferenceImageNum": "0",
          "BillingName": "ナカダイ（菓子）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230616",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230614",
          "ImageInstructUserId": "hirabaa2",
          "ImageInstructUser": "",
          "BuyerName": "木内咲枝",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230627 19:25:07",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4962679639638",
          "ImageGroupNo": "577415",
          "SmallClass": "ぐるめぐり豆菓子",
          "BuyerCode": "00500028",
          "BillingCode": "967807",
          "SampleOrderingCode": "967807",
          "SampleOrderingName": "ナカダイ（菓子）",
          "SupplierSalesStaffName": "",
          "PCode": "P2564332"
        },
        {
          "ImageFileName": "P2200481C_25",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "十勝産スイートコーン　〈うらごしタイプ〉",
          "GuideStandardName": "１８０ｇ×３",
          "PhotoContentsName": "",
          "StartOrderCode": "2023190",
          "DelivCatalogId": "20230704",
          "ImageId": "678208",
          "Enabled": "0",
          "ImageName": "P2200481C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230707",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230705",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230714 11:57:21",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220310852",
          "ImageGroupNo": "579097",
          "SmallClass": "スィートコーン缶",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2200481"
        },
        {
          "ImageFileName": "P2200481C_26",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "十勝産スイートコーン　〈うらごしタイプ〉",
          "GuideStandardName": "１８０ｇ×３",
          "PhotoContentsName": "",
          "StartOrderCode": "2023190",
          "DelivCatalogId": "20230704",
          "ImageId": "678209",
          "Enabled": "0",
          "ImageName": "P2200481C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230707",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230705",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230802 18:06:42",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220310852",
          "ImageGroupNo": "579097",
          "SmallClass": "スィートコーン缶",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2200481"
        },
        {
          "ImageFileName": "P2200481C_27",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "十勝産スイートコーン　〈うらごしタイプ〉",
          "GuideStandardName": "１８０ｇ×３",
          "PhotoContentsName": "",
          "StartOrderCode": "2023190",
          "DelivCatalogId": "20230704",
          "ImageId": "678210",
          "Enabled": "0",
          "ImageName": "P2200481C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230707",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230705",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230802 18:06:43",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220310852",
          "ImageGroupNo": "579097",
          "SmallClass": "スィートコーン缶",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2200481"
        },
        {
          "ImageFileName": "P2228858C_27",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "かんてんパウダー",
          "GuideStandardName": "２ｇ×１６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023190",
          "DelivCatalogId": "20230704",
          "ImageId": "678214",
          "Enabled": "0",
          "ImageName": "P2228858C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "07",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230707",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230705",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230718 20:13:57",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220281930",
          "ImageGroupNo": "579100",
          "SmallClass": "デザート",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2228858"
        },
        {
          "ImageFileName": "P2508060C_09",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "じゃがいも（とうや）",
          "GuideStandardName": "１ｋｇ（サイズ込）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "673656",
          "Enabled": "0",
          "ImageName": "P2508060C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230605",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "fujimatr",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:39",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000009023",
          "ImageGroupNo": "576548",
          "SmallClass": "ジャガイモ",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2508060"
        },
        {
          "ImageFileName": "P2657641C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "小玉高原キャベツ（群馬県産）",
          "GuideStandardName": "１個（６００ｇ）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "674939",
          "Enabled": "0",
          "ImageName": "P2657641C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230613",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230613",
          "ImageInstructUserId": "katok   ",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230711 18:56:36",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000128854",
          "ImageGroupNo": "577303",
          "SmallClass": "キャベツ",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2657641"
        },
        {
          "ImageFileName": "P2668516C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1252610-N4NN5XKO-N4NN5XKO",
          "GuideGoodsName": "玉ねぎソースのハンバーグ（野菜添え）",
          "GuideStandardName": "３２５ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "660445",
          "Enabled": "0",
          "ImageName": "P2668516C",
          "ClassCode": "03",
          "ClassName": "畜産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "ホーム食品（クルコ用）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230307",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230227",
          "ImageInstructUserId": "nishiym9",
          "ImageInstructUser": "",
          "BuyerName": "にいがた地域",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230822 19:25:18",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4907653126148",
          "ImageGroupNo": "568678",
          "SmallClass": "その他",
          "BuyerCode": "00800005",
          "BillingCode": "976997",
          "SampleOrderingCode": "976997",
          "SampleOrderingName": "ホーム食品（クルコ用）",
          "SupplierSalesStaffName": "",
          "PCode": "P2668516"
        },
        {
          "ImageFileName": "P2225662C_17",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "華色そうめん",
          "GuideStandardName": "３００ｇ×２袋",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "679558",
          "Enabled": "0",
          "ImageName": "P2225662C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "下田商事",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230714",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230712",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 14:33:46",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4904603111971",
          "ImageGroupNo": "580009",
          "SmallClass": "素麺・冷麦",
          "BuyerCode": "00600019",
          "BillingCode": "960357",
          "SampleOrderingCode": "960357",
          "SampleOrderingName": "下田商事",
          "SupplierSalesStaffName": "",
          "PCode": "P2225662"
        },
        {
          "ImageFileName": "P2633638C_10",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00122678-00010000",
          "GuideGoodsName": "はごろもシーチキンマイルド水煮",
          "GuideStandardName": "５０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "673617",
          "Enabled": "0",
          "ImageName": "P2633638C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "２０２３．８－１ヴィ・ナチュール表紙",
          "PhotoSchedule": "20230601",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "ushijimh",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:55",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4902220093694",
          "ImageGroupNo": "576522",
          "SmallClass": "ツナ缶（ノンオイル）",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2633638"
        },
        {
          "ImageFileName": "P2634912C_07",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00122678-00010000",
          "GuideGoodsName": "はごろもシーチキンマイルド水煮",
          "GuideStandardName": "５０ｇ×６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "673616",
          "Enabled": "0",
          "ImageName": "P2634912C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "２０２３．８－１ヴィ・ナチュール表紙",
          "PhotoSchedule": "20230601",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "ushijimh",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230705 13:50:55",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4902220093694",
          "ImageGroupNo": "576521",
          "SmallClass": "ツナ缶（ノンオイル）",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2634912"
        },
        {
          "ImageFileName": "P2671794C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E9485521-N6GX3USA-N6GX3USA",
          "GuideGoodsName": "パッションパインパイ",
          "GuideStandardName": "４個",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "673480",
          "Enabled": "0",
          "ImageName": "P2671794C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "ＹＫベーキングカンパニー",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230606",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230601",
          "ImageInstructUserId": "shindoy4",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230721 15:25:52",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4901408651145",
          "ImageGroupNo": "576438",
          "SmallClass": "パイ",
          "BuyerCode": "00500033",
          "BillingCode": "939714",
          "SampleOrderingCode": "939714",
          "SampleOrderingName": "ＹＫベーキングカンパニー",
          "SupplierSalesStaffName": "",
          "PCode": "P2671794"
        },
        {
          "ImageFileName": "P2172208C_18",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "ちーちゃいうどん",
          "GuideStandardName": "４８０ｇ（めん８０ｇ×６）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "679542",
          "Enabled": "0",
          "ImageName": "P2172208C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "三菱食品（特殊冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230714",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230712",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230725 18:35:30",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4548779702474",
          "ImageGroupNo": "580003",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "973246",
          "SampleOrderingCode": "973246",
          "SampleOrderingName": "三菱食品（特殊冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2172208"
        },
        {
          "ImageFileName": "P2172208C_19",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "ちーちゃいうどん",
          "GuideStandardName": "４８０ｇ（めん８０ｇ×６）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "679543",
          "Enabled": "0",
          "ImageName": "P2172208C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "数量:1人分,数量／個数:1,数量／器数:2,器形状:皿,器:和,イメージ:ランチ,断面:1個カットして中見せ,撮影演出:箸で持つ",
          "ReferenceImageNum": "0",
          "BillingName": "三菱食品（特殊冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230714",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230712",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230725 18:35:30",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4548779702474",
          "ImageGroupNo": "580003",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "973246",
          "SampleOrderingCode": "973246",
          "SampleOrderingName": "三菱食品（特殊冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2172208"
        },
        {
          "ImageFileName": "P2172208C_20",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "ちーちゃいうどん",
          "GuideStandardName": "４８０ｇ（めん８０ｇ×６）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023200",
          "DelivCatalogId": "20230801",
          "ImageId": "679544",
          "Enabled": "0",
          "ImageName": "P2172208C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "三菱食品（特殊冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230714",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230712",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230725 18:35:30",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4548779702474",
          "ImageGroupNo": "580003",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "973246",
          "SampleOrderingCode": "973246",
          "SampleOrderingName": "三菱食品（特殊冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2172208"
        },
        {
          "ImageFileName": "P2546707C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "不揃い南郷トマト",
          "GuideStandardName": "８００ｇ（サイズ込）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023210",
          "DelivCatalogId": "20230802",
          "ImageId": "676484",
          "Enabled": "0",
          "ImageName": "P2546707C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230621",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230621",
          "ImageInstructUserId": "fujinoh ",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230711 18:56:04",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000037620",
          "ImageGroupNo": "578177",
          "SmallClass": "トマト",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2546707"
        },
        {
          "ImageFileName": "P2546707C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "不揃い南郷トマト",
          "GuideStandardName": "８００ｇ（サイズ込）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023210",
          "DelivCatalogId": "20230802",
          "ImageId": "676485",
          "Enabled": "0",
          "ImageName": "P2546707C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230621",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230621",
          "ImageInstructUserId": "fujinoh ",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230711 18:56:05",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000037620",
          "ImageGroupNo": "578178",
          "SmallClass": "トマト",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2546707"
        },
        {
          "ImageFileName": "P2666705C_06",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00102813-00170000",
          "GuideGoodsName": "サラダフレーク",
          "GuideStandardName": "１２０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023210",
          "DelivCatalogId": "20230802",
          "ImageId": "680891",
          "Enabled": "0",
          "ImageName": "P2666705C",
          "ClassCode": "04",
          "ClassName": "日配",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "01",
          "TempRangeName": "冷蔵",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230721",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230719",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "安倍智勇",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230802 18:07:06",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220194230",
          "ImageGroupNo": "580793",
          "SmallClass": "その他",
          "BuyerCode": "00500021",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2666705"
        },
        {
          "ImageFileName": "P2672231E_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E5877478-N6H07OW9-N6H07OW9",
          "GuideGoodsName": "つじりの里　Ｒｉｃｈ",
          "GuideStandardName": "１５本（個包装）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023210",
          "DelivCatalogId": "20230802",
          "ImageId": "675219",
          "Enabled": "0",
          "ImageName": "P2672231E",
          "ClassCode": "05",
          "ClassName": "菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "1",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "高山（菓子）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230614",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230614",
          "ImageInstructUserId": "iwasakk6",
          "ImageInstructUser": "",
          "BuyerName": "木内咲枝",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230711 19:00:19",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4986990817308",
          "ImageGroupNo": "577501",
          "SmallClass": "ぐるめぐりビスケット",
          "BuyerCode": "00500028",
          "BillingCode": "933988",
          "SampleOrderingCode": "933988",
          "SampleOrderingName": "高山（菓子）",
          "SupplierSalesStaffName": "",
          "PCode": "P2672231"
        },
        {
          "ImageFileName": "P2673384C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E2199635-N6WG68QW-N6WG68QW",
          "GuideGoodsName": "ビスコ保存缶",
          "GuideStandardName": "３０枚（５枚×６パック）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023220",
          "DelivCatalogId": "20230803",
          "ImageId": "680625",
          "Enabled": "0",
          "ImageName": "P2673384C",
          "ClassCode": "05",
          "ClassName": "菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "ナシオ（菓子）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230717",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230717",
          "ImageInstructUserId": "nagasawj",
          "ImageInstructUser": "",
          "BuyerName": "木内咲枝",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4901005532724",
          "ImageGroupNo": "580637",
          "SmallClass": "その他",
          "BuyerCode": "00500028",
          "BillingCode": "921998",
          "SampleOrderingCode": "921998",
          "SampleOrderingName": "ナシオ（菓子）",
          "SupplierSalesStaffName": "",
          "PCode": "P2673384"
        },
        {
          "ImageFileName": "P2571585C_04",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E8226096-LPH11F1R-LPH11F1R",
          "GuideGoodsName": "即席焼ビーフン３個パック",
          "GuideStandardName": "１９５ｇ（６５ｇ×３）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023220",
          "DelivCatalogId": "20230803",
          "ImageId": "682146",
          "Enabled": "0",
          "ImageName": "P2571585C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "下田商事",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230728",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230726",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230804 11:07:56",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4901483021154",
          "ImageGroupNo": "581578",
          "SmallClass": "その他",
          "BuyerCode": "00600020",
          "BillingCode": "960357",
          "SampleOrderingCode": "960357",
          "SampleOrderingName": "下田商事",
          "SupplierSalesStaffName": "",
          "PCode": "P2571585"
        },
        {
          "ImageFileName": "P2638462C_04",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F2038001-MLI91I54-MLI91I54",
          "GuideGoodsName": "秋川牧園　チキンナゲット",
          "GuideStandardName": "１８０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023220",
          "DelivCatalogId": "20230803",
          "ImageId": "676033",
          "Enabled": "0",
          "ImageName": "P2638462C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "秋川牧園",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "２０２３・８－３ヴィ・ナチュール表紙",
          "PhotoSchedule": "20230615",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230619",
          "ImageInstructUserId": "ushijimh",
          "ImageInstructUser": "",
          "BuyerName": "海邊麻夕子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230718 20:14:05",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4958446406053",
          "ImageGroupNo": "577894",
          "SmallClass": "その他",
          "BuyerCode": "00500009",
          "BillingCode": "980609",
          "SampleOrderingCode": "980609",
          "SampleOrderingName": "秋川牧園",
          "SupplierSalesStaffName": "",
          "PCode": "P2638462"
        },
        {
          "ImageFileName": "P2671545C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "S1978988-N6D19IME-N6D19IME",
          "GuideGoodsName": "コロちゃんのコロッケ屋！レンジでハムカツ",
          "GuideStandardName": "４個入り（１８０ｇ）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023220",
          "DelivCatalogId": "20230803",
          "ImageId": "673633",
          "Enabled": "0",
          "ImageName": "P2671545C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "ニッキーフーズ（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230605",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "ikenos  ",
          "ImageInstructUser": "",
          "BuyerName": "海邊麻夕子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230718 20:14:56",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4970176439675",
          "ImageGroupNo": "576535",
          "SmallClass": "畜産",
          "BuyerCode": "00500009",
          "BillingCode": "973351",
          "SampleOrderingCode": "973351",
          "SampleOrderingName": "ニッキーフーズ（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2671545"
        },
        {
          "ImageFileName": "P2671545D_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "S1978988-N6D19IME-N6D19IME",
          "GuideGoodsName": "コロちゃんのコロッケ屋！レンジでハムカツ",
          "GuideStandardName": "４個入り（１８０ｇ）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023220",
          "DelivCatalogId": "20230803",
          "ImageId": "673634",
          "Enabled": "0",
          "ImageName": "P2671545D",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "1",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "ニッキーフーズ（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230605",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "ikenos  ",
          "ImageInstructUser": "",
          "BuyerName": "海邊麻夕子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230704 15:23:57",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4970176439675",
          "ImageGroupNo": "576536",
          "SmallClass": "畜産",
          "BuyerCode": "00500009",
          "BillingCode": "973351",
          "SampleOrderingCode": "973351",
          "SampleOrderingName": "ニッキーフーズ（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2671545"
        },
        {
          "ImageFileName": "P2594929C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E5172746-M1WF6NTP-M1WF6NTP",
          "GuideGoodsName": "めばちまぐろ刺身用（中とろ）",
          "GuideStandardName": "２００ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "671127",
          "Enabled": "0",
          "ImageName": "P2594929C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "トライ産業",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230602",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230523",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "百田厚彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230725 18:35:44",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4519720013109",
          "ImageGroupNo": "575226",
          "SmallClass": "刺身生食ぐるめぐり",
          "BuyerCode": "00200006",
          "BillingCode": "945986",
          "SampleOrderingCode": "945986",
          "SampleOrderingName": "トライ産業",
          "SupplierSalesStaffName": "",
          "PCode": "P2594929"
        },
        {
          "ImageFileName": "P2599670C_10",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1134822-M2OE0AAB-M2OE0AAB",
          "GuideGoodsName": "赤ちゃん用　野菜入りみそスープ",
          "GuideStandardName": "２．２ｇ×８袋入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "682806",
          "Enabled": "0",
          "ImageName": "P2599670C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230804",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230801",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 14:33:53",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902475212215",
          "ImageGroupNo": "581981",
          "SmallClass": "フリーズドライＢＦ",
          "BuyerCode": "00600019",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2599670"
        },
        {
          "ImageFileName": "P2599670C_11",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1134822-M2OE0AAB-M2OE0AAB",
          "GuideGoodsName": "赤ちゃん用　野菜入りみそスープ",
          "GuideStandardName": "２．２ｇ×８袋入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "682807",
          "Enabled": "0",
          "ImageName": "P2599670C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230804",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230801",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 14:33:54",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902475212215",
          "ImageGroupNo": "581981",
          "SmallClass": "フリーズドライＢＦ",
          "BuyerCode": "00600019",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2599670"
        },
        {
          "ImageFileName": "P2599670C_12",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E1134822-M2OE0AAB-M2OE0AAB",
          "GuideGoodsName": "赤ちゃん用　野菜入りみそスープ",
          "GuideStandardName": "２．２ｇ×８袋入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "682808",
          "Enabled": "0",
          "ImageName": "P2599670C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230804",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230801",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 14:33:54",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902475212215",
          "ImageGroupNo": "581981",
          "SmallClass": "フリーズドライＢＦ",
          "BuyerCode": "00600019",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2599670"
        },
        {
          "ImageFileName": "P2601688C_08",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00015910-00140000",
          "GuideGoodsName": "野菜たっぷり和風ドレッシング",
          "GuideStandardName": "１５０ｍｌ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "682809",
          "Enabled": "0",
          "ImageName": "P2601688C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230804",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230801",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "長谷川桂",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 14:33:54",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220024124",
          "ImageGroupNo": "581982",
          "SmallClass": "ドレッシング",
          "BuyerCode": "00600018",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2601688"
        },
        {
          "ImageFileName": "P2629820D_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "こども安全包丁",
          "GuideStandardName": "はらぺこあおむし",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "672547",
          "Enabled": "0",
          "ImageName": "P2629820D",
          "ClassCode": "07",
          "ClassName": "住関連",
          "C2pfTarget": "1",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "2",
          "ImageUseMethodName": "Mdb画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "1",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "過去画像情報サンプル",
          "ImageCaution": "切抜or角版:切り抜き（背景なし）",
          "ReferenceImageNum": "0",
          "BillingName": "くらし企画",
          "C2pfStatus": "2",
          "DelayFlag": "0",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230609",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230529",
          "ImageInstructUserId": "yoshioy6",
          "ImageInstructUser": "",
          "BuyerName": "早野正人",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230616 12:07:53",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4984909330979",
          "ImageGroupNo": "575964",
          "SmallClass": "住関きらきら",
          "BuyerCode": "00820005",
          "BillingCode": "957941",
          "SampleOrderingCode": "957941",
          "SampleOrderingName": "くらし企画",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2629820"
        },
        {
          "ImageFileName": "P2629820D_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "こども安全包丁",
          "GuideStandardName": "はらぺこあおむし",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "672548",
          "Enabled": "0",
          "ImageName": "P2629820D",
          "ClassCode": "07",
          "ClassName": "住関連",
          "C2pfTarget": "1",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "2",
          "ImageUseMethodName": "Mdb画像使用",
          "PhotographingNo": "1         ",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "1",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "くらし企画",
          "C2pfStatus": "2",
          "DelayFlag": "0",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230609",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230529",
          "ImageInstructUserId": "yoshioy6",
          "ImageInstructUser": "",
          "BuyerName": "早野正人",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230725 18:35:52",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4984909330979",
          "ImageGroupNo": "575964",
          "SmallClass": "住関きらきら",
          "BuyerCode": "00820005",
          "BillingCode": "957941",
          "SampleOrderingCode": "957941",
          "SampleOrderingName": "くらし企画",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2629820"
        },
        {
          "ImageFileName": "P2629820D_05",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "こども安全包丁",
          "GuideStandardName": "はらぺこあおむし",
          "PhotoContentsName": "",
          "StartOrderCode": "2023230",
          "DelivCatalogId": "20230804",
          "ImageId": "675857",
          "Enabled": "0",
          "ImageName": "P2629820D",
          "ClassCode": "07",
          "ClassName": "住関連",
          "C2pfTarget": "1",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "2",
          "ImageUseMethodName": "Mdb画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "1",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "くらし企画",
          "C2pfStatus": "2",
          "DelayFlag": "0",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230623",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230616",
          "ImageInstructUserId": "tanakak3",
          "ImageInstructUser": "",
          "BuyerName": "早野正人",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230725 18:35:52",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4984909330979",
          "ImageGroupNo": "577826",
          "SmallClass": "住関きらきら",
          "BuyerCode": "00820005",
          "BillingCode": "957941",
          "SampleOrderingCode": "957941",
          "SampleOrderingName": "くらし企画",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2629820"
        },
        {
          "ImageFileName": "P2671051C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E6583495-N5PM5J9I-N5PM5J9I",
          "GuideGoodsName": "銚子兆星のいか開き一夜干し",
          "GuideStandardName": "２４０ｇ（２枚）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023240",
          "DelivCatalogId": "20230805",
          "ImageId": "669830",
          "Enabled": "0",
          "ImageName": "P2671051C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "兆星",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230519",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230504",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "百田厚彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230802 18:07:36",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4949711502006",
          "ImageGroupNo": "574431",
          "SmallClass": "惣菜魚２ぐるめぐり",
          "BuyerCode": "00200006",
          "BillingCode": "946621",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2671051"
        },
        {
          "ImageFileName": "P2671051C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E6583495-N5PM5J9I-N5PM5J9I",
          "GuideGoodsName": "銚子兆星のいか開き一夜干し",
          "GuideStandardName": "２４０ｇ（２枚）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023240",
          "DelivCatalogId": "20230805",
          "ImageId": "669831",
          "Enabled": "0",
          "ImageName": "P2671051C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "兆星",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230519",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230504",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "百田厚彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230802 18:07:36",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4949711502006",
          "ImageGroupNo": "574431",
          "SmallClass": "惣菜魚２ぐるめぐり",
          "BuyerCode": "00200006",
          "BillingCode": "946621",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2671051"
        },
        {
          "ImageFileName": "P2659526C_14",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00012772-00150000",
          "GuideGoodsName": "ふっくら味付いなりあげ",
          "GuideStandardName": "１０枚（５枚×２）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023240",
          "DelivCatalogId": "20230805",
          "ImageId": "683898",
          "Enabled": "0",
          "ImageName": "P2659526C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230811",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230809",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "長谷川桂",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230822 19:25:07",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220177509",
          "ImageGroupNo": "582652",
          "SmallClass": "飯の素・寿司の素",
          "BuyerCode": "00600018",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2659526"
        },
        {
          "ImageFileName": "P2671700E_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "S5324717-N6289CLZ-N6289CLZ",
          "GuideGoodsName": "しあわせの激辛　チキンカレー",
          "GuideStandardName": "１人前（２２０ｇ）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023240",
          "DelivCatalogId": "20230805",
          "ImageId": "673641",
          "Enabled": "0",
          "ImageName": "P2671700E",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "1",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230606",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "fukuday5",
          "ImageInstructUser": "",
          "BuyerName": "長谷川桂",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230614 13:19:43",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4902402895429",
          "ImageGroupNo": "576243",
          "SmallClass": "カレーレトルト",
          "BuyerCode": "00600018",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2671700"
        },
        {
          "ImageFileName": "P2533355C_38",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00112702-00010000",
          "GuideGoodsName": "北海道のうらごし枝豆",
          "GuideStandardName": "１２０ｇ（標準１２個）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023240",
          "DelivCatalogId": "20230805",
          "ImageId": "683891",
          "Enabled": "0",
          "ImageName": "P2533355C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230811",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230809",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230822 19:24:39",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220518890",
          "ImageGroupNo": "582647",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2533355"
        },
        {
          "ImageFileName": "P2533355C_39",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00112702-00010000",
          "GuideGoodsName": "北海道のうらごし枝豆",
          "GuideStandardName": "１２０ｇ（標準１２個）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023240",
          "DelivCatalogId": "20230805",
          "ImageId": "683892",
          "Enabled": "0",
          "ImageName": "P2533355C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230811",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230809",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230822 19:24:39",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220518890",
          "ImageGroupNo": "582647",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2533355"
        },
        {
          "ImageFileName": "P2533355C_40",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "F1161011-00112702-00010000",
          "GuideGoodsName": "北海道のうらごし枝豆",
          "GuideStandardName": "１２０ｇ（標準１２個）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023240",
          "DelivCatalogId": "20230805",
          "ImageId": "683893",
          "Enabled": "0",
          "ImageName": "P2533355C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "08",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230811",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230809",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230822 19:24:39",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220518890",
          "ImageGroupNo": "582647",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2533355"
        },
        {
          "ImageFileName": "P2520203C_04",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "れんこん",
          "GuideStandardName": "３００ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "679241",
          "Enabled": "0",
          "ImageName": "P2520203C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230710",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230710",
          "ImageInstructUserId": "fujimatr",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230809 12:44:08",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000017677",
          "ImageGroupNo": "579812",
          "SmallClass": "れんこん",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2520203"
        },
        {
          "ImageFileName": "P2536661C_16",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "大口れんこん",
          "GuideStandardName": "４００ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "679239",
          "Enabled": "0",
          "ImageName": "P2536661C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230710",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230710",
          "ImageInstructUserId": "fujimatr",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230809 12:44:10",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000027720",
          "ImageGroupNo": "579810",
          "SmallClass": "れんこん",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2536661"
        },
        {
          "ImageFileName": "P2587762C_12",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "",
          "GuideGoodsName": "若鶏ササミ挽肉パラパラミンチ",
          "GuideStandardName": "３５０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "685146",
          "Enabled": "0",
          "ImageName": "P2587762C",
          "ClassCode": "03",
          "ClassName": "畜産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "4",
          "ImageUseMethodName": "過去画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "過去画像情報サンプル",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープデリフーズ（畜産）",
          "C2pfStatus": "8",
          "DelayFlag": "0",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230818",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230816",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "中村清一",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230816 12:38:08",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4536678032648",
          "ImageGroupNo": "583362",
          "SmallClass": "通常挽き",
          "BuyerCode": "00300005",
          "BillingCode": "972835",
          "SampleOrderingCode": "972835",
          "SampleOrderingName": "コープデリフーズ（畜産）",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2587762"
        },
        {
          "ImageFileName": "P2587762C_13",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "",
          "GuideGoodsName": "若鶏ササミ挽肉パラパラミンチ",
          "GuideStandardName": "３５０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "685149",
          "Enabled": "0",
          "ImageName": "P2587762C",
          "ClassCode": "03",
          "ClassName": "畜産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "1",
          "ImageUseMethodName": "撮影",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "過去画像情報サンプル",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープデリフーズ（畜産）",
          "C2pfStatus": "8",
          "DelayFlag": "0",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230818",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230816",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "中村清一",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230816 12:38:08",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4536678032648",
          "ImageGroupNo": "583362",
          "SmallClass": "通常挽き",
          "BuyerCode": "00300005",
          "BillingCode": "972835",
          "SampleOrderingCode": "972835",
          "SampleOrderingName": "コープデリフーズ（畜産）",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2587762"
        },
        {
          "ImageFileName": "P2587762C_14",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "",
          "GuideGoodsName": "若鶏ササミ挽肉パラパラミンチ",
          "GuideStandardName": "３５０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "685150",
          "Enabled": "0",
          "ImageName": "P2587762C",
          "ClassCode": "03",
          "ClassName": "畜産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "4",
          "ImageUseMethodName": "過去画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "過去画像情報サンプル",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープデリフーズ（畜産）",
          "C2pfStatus": "1",
          "DelayFlag": "0",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230818",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230816",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "中村清一",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230816 12:38:08",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4536678032648",
          "ImageGroupNo": "583362",
          "SmallClass": "通常挽き",
          "BuyerCode": "00300005",
          "BillingCode": "972835",
          "SampleOrderingCode": "972835",
          "SampleOrderingName": "コープデリフーズ（畜産）",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2587762"
        },
        {
          "ImageFileName": "P2504255A_25",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E8529534-KND301A1-KND301A1",
          "GuideGoodsName": "野菜一日これ一本",
          "GuideStandardName": "２００ｍｌ×１２",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "673620",
          "Enabled": "0",
          "ImageName": "P2504255A",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230613",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "matsuna4",
          "ImageInstructUser": "",
          "BuyerName": "久保田一弥",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230809 12:44:06",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4901306247563",
          "ImageGroupNo": "576524",
          "SmallClass": "人参ミックス果汁",
          "BuyerCode": "00600014",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2504255"
        },
        {
          "ImageFileName": "P2648768A_03",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "S8555415-MT0B91P0-MT0B91P0",
          "GuideGoodsName": "朝のフルーツこれ一本",
          "GuideStandardName": "２００ｍｌ×１２",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "673623",
          "Enabled": "0",
          "ImageName": "P2648768A",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230613",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "matsuna4",
          "ImageInstructUser": "",
          "BuyerName": "久保田一弥",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230621 15:51:36",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4901306169445",
          "ImageGroupNo": "576527",
          "SmallClass": "ミックス果汁",
          "BuyerCode": "00600014",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2648768"
        },
        {
          "ImageFileName": "P2660891C_04",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "F1161011-00126097-00010000",
          "GuideGoodsName": "ひじきドライパック（増量）",
          "GuideStandardName": "５０ｇ×５＋１袋",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "685151",
          "Enabled": "0",
          "ImageName": "P2660891C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230818",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230816",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "原真友",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 12:38:08",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220186099",
          "ImageGroupNo": "583365",
          "SmallClass": "ひじき缶",
          "BuyerCode": "00600020",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2660891"
        },
        {
          "ImageFileName": "P2671578C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "G9361999-N65R92V0-N65R92V0",
          "GuideGoodsName": "カニカマ天",
          "GuideStandardName": "１８０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023250",
          "DelivCatalogId": "20230901",
          "ImageId": "673630",
          "Enabled": "0",
          "ImageName": "P2671578C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "三菱食品（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230605",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "ikenos  ",
          "ImageInstructUser": "",
          "BuyerName": "海邊麻夕子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230809 12:45:26",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4972195753916",
          "ImageGroupNo": "576532",
          "SmallClass": "その他",
          "BuyerCode": "00500009",
          "BillingCode": "973254",
          "SampleOrderingCode": "973254",
          "SampleOrderingName": "三菱食品（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2671578"
        },
        {
          "ImageFileName": "P2599304C_04",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E5341931-M37118NT-M37118NT",
          "GuideGoodsName": "イブシギンのしぜんだし（粉末タイプ）",
          "GuideStandardName": "１００ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "681849",
          "Enabled": "0",
          "ImageName": "P2599304C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "Ｔ＆Ｔジャパン",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230725",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230725",
          "ImageInstructUserId": "hayashiu",
          "ImageInstructUser": "",
          "BuyerName": "斎藤岳",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230728 13:09:41",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4562376323207",
          "ImageGroupNo": "581360",
          "SmallClass": "和風調味料１ぐる",
          "BuyerCode": "00600010",
          "BillingCode": "975494",
          "SampleOrderingCode": "975494",
          "SampleOrderingName": "Ｔ＆Ｔジャパン",
          "SupplierSalesStaffName": "",
          "PCode": "P2599304"
        },
        {
          "ImageFileName": "P2609556A_09",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E8643523-M9HO33OW-M9HO33OW",
          "GuideGoodsName": "ワンダ　モーニングショット",
          "GuideStandardName": "１８５ｇ×６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "673629",
          "Enabled": "0",
          "ImageName": "P2609556A",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230613",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "matsuna4",
          "ImageInstructUser": "",
          "BuyerName": "久保田一弥",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 14:33:55",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4514603284324",
          "ImageGroupNo": "576531",
          "SmallClass": "コーヒードリンク",
          "BuyerCode": "00600014",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2609556"
        },
        {
          "ImageFileName": "P2638084C_11",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E5928618-MKWH350U-MKWH350U",
          "GuideGoodsName": "かぼちゃフレーク",
          "GuideStandardName": "６０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "685797",
          "Enabled": "0",
          "ImageName": "P2638084C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230825",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230821",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230821 13:01:43",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4524689000510",
          "ImageGroupNo": "583727",
          "SmallClass": "フリーズドライＢＦ",
          "BuyerCode": "00600019",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2638084"
        },
        {
          "ImageFileName": "P2644238A_09",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "S8555415-MQBM9EBZ-MQBM9EBZ",
          "GuideGoodsName": "野菜一日これ一本Ｌｉｇｈｔ糖質５０％オフ",
          "GuideStandardName": "２００ｍｌ×１２",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "673636",
          "Enabled": "0",
          "ImageName": "P2644238A",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "加藤産業（食品）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230613",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230605",
          "ImageInstructUserId": "matsuna4",
          "ImageInstructUser": "",
          "BuyerName": "久保田一弥",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230817 11:59:53",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4901306137666",
          "ImageGroupNo": "576538",
          "SmallClass": "その他",
          "BuyerCode": "00600014",
          "BillingCode": "921831",
          "SampleOrderingCode": "921831",
          "SampleOrderingName": "加藤産業（食品）",
          "SupplierSalesStaffName": "",
          "PCode": "P2644238"
        },
        {
          "ImageFileName": "P2673229C_03",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E5341931-N7725D64-N7725D64",
          "GuideGoodsName": "イブシギンのしぜんだし（粉末タイプ）",
          "GuideStandardName": "８０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "681850",
          "Enabled": "0",
          "ImageName": "P2673229C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "Ｔ＆Ｔジャパン",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230725",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230725",
          "ImageInstructUserId": "hayashiu",
          "ImageInstructUser": "",
          "BuyerName": "斎藤岳",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 14:36:26",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4562376323290",
          "ImageGroupNo": "581361",
          "SmallClass": "だしの素",
          "BuyerCode": "00600010",
          "BillingCode": "975494",
          "SampleOrderingCode": "975494",
          "SampleOrderingName": "Ｔ＆Ｔジャパン",
          "SupplierSalesStaffName": "",
          "PCode": "P2673229"
        },
        {
          "ImageFileName": "P2513714C_41",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "F1161011-00107816-00090000",
          "GuideGoodsName": "国産ポーク皮なしウインナー",
          "GuideStandardName": "７２ｇ×２",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "685801",
          "Enabled": "0",
          "ImageName": "P2513714C",
          "ClassCode": "08",
          "ClassName": "加工肉",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "01",
          "TempRangeName": "冷蔵",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230825",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230821",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "鰐渕恭子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230821 13:01:43",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220104017",
          "ImageGroupNo": "583729",
          "SmallClass": "皮なし",
          "BuyerCode": "00500035",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2513714"
        },
        {
          "ImageFileName": "P2662124C_06",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "F1161011-00126062-00010000",
          "GuideGoodsName": "国産大豆と角切り野菜入りかぼちゃ豆乳ソース",
          "GuideStandardName": "８個入（１６０ｇ）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "685796",
          "Enabled": "0",
          "ImageName": "P2662124C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本生協連中央支所",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230825",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230821",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230821 13:01:43",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4902220173730",
          "ImageGroupNo": "583726",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "990000",
          "SampleOrderingCode": "990000",
          "SampleOrderingName": "日本生協連中央支所",
          "SupplierSalesStaffName": "",
          "PCode": "P2662124"
        },
        {
          "ImageFileName": "P2669173C_19",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E5218130-MGQE5HK9-N3AZ5GKU",
          "GuideGoodsName": "プチほうれん草３０",
          "GuideStandardName": "１５０ｇ（３０ｇ×５袋）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "685798",
          "Enabled": "0",
          "ImageName": "P2669173C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本アクセス（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230825",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230821",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230821 13:01:43",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4901602210629",
          "ImageGroupNo": "583728",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "969494",
          "SampleOrderingCode": "969494",
          "SampleOrderingName": "日本アクセス（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2669173"
        },
        {
          "ImageFileName": "P2669173C_20",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E5218130-MGQE5HK9-N3AZ5GKU",
          "GuideGoodsName": "プチほうれん草３０",
          "GuideStandardName": "１５０ｇ（３０ｇ×５袋）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "685799",
          "Enabled": "0",
          "ImageName": "P2669173C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本アクセス（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230825",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230821",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230821 13:01:43",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4901602210629",
          "ImageGroupNo": "583728",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "969494",
          "SampleOrderingCode": "969494",
          "SampleOrderingName": "日本アクセス（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2669173"
        },
        {
          "ImageFileName": "P2669173C_21",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E5218130-MGQE5HK9-N3AZ5GKU",
          "GuideGoodsName": "プチほうれん草３０",
          "GuideStandardName": "１５０ｇ（３０ｇ×５袋）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023260",
          "DelivCatalogId": "20230902",
          "ImageId": "685800",
          "Enabled": "0",
          "ImageName": "P2669173C",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "日本アクセス（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230825",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230821",
          "ImageInstructUserId": "miyashy2",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230821 13:01:43",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷（きらきら）",
          "JanCode": "4901602210629",
          "ImageGroupNo": "583728",
          "SmallClass": "冷食きらきら",
          "BuyerCode": "00500029",
          "BillingCode": "969494",
          "SampleOrderingCode": "969494",
          "SampleOrderingName": "日本アクセス（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2669173"
        },
        {
          "ImageFileName": "P2513118C_09",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "ミニトマト",
          "GuideStandardName": "２００ｇ（サイズ込）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023280",
          "DelivCatalogId": "20230904",
          "ImageId": "683782",
          "Enabled": "0",
          "ImageName": "P2513118C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "P0754196より流用",
          "PhotoSchedule": "20230808",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230808",
          "ImageInstructUserId": "suzukis2",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000013037",
          "ImageGroupNo": "582572",
          "SmallClass": "ミニトマト",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2513118"
        },
        {
          "ImageFileName": "P2595002C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "曽我農園のトマト（トメイトゥ）",
          "GuideStandardName": "１ｋｇ箱（サイズ込）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023280",
          "DelivCatalogId": "20230904",
          "ImageId": "683783",
          "Enabled": "0",
          "ImageName": "P2595002C",
          "ClassCode": "01",
          "ClassName": "農産",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "コープネット農産",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "P2505352より流用",
          "PhotoSchedule": "20230808",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230808",
          "ImageInstructUserId": "suzukis2",
          "ImageInstructUser": "",
          "BuyerName": "Ａ",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "2400000074861",
          "ImageGroupNo": "582573",
          "SmallClass": "トマト",
          "BuyerCode": "00100001",
          "BillingCode": "947385",
          "SampleOrderingCode": "947385",
          "SampleOrderingName": "コープネット農産",
          "SupplierSalesStaffName": "",
          "PCode": "P2595002"
        },
        {
          "ImageFileName": "P2671042C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E6583495-N5QY3YDK-N5QY3YDK",
          "GuideGoodsName": "銚子兆星のいか一夜干し（短冊カット）",
          "GuideStandardName": "１８０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023280",
          "DelivCatalogId": "20230904",
          "ImageId": "669822",
          "Enabled": "0",
          "ImageName": "P2671042C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "兆星",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230516",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230504",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "谷口",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230524 13:07:45",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4949711502013",
          "ImageGroupNo": "574426",
          "SmallClass": "その他干物",
          "BuyerCode": "00200002",
          "BillingCode": "946621",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2671042"
        },
        {
          "ImageFileName": "P2671042C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E6583495-N5QY3YDK-N5QY3YDK",
          "GuideGoodsName": "銚子兆星のいか一夜干し（短冊カット）",
          "GuideStandardName": "１８０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023280",
          "DelivCatalogId": "20230904",
          "ImageId": "669823",
          "Enabled": "0",
          "ImageName": "P2671042C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "兆星",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230516",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230504",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "谷口",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230524 13:07:46",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4949711502013",
          "ImageGroupNo": "574426",
          "SmallClass": "その他干物",
          "BuyerCode": "00200002",
          "BillingCode": "946621",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2671042"
        },
        {
          "ImageFileName": "P2670388C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "",
          "GuideGoodsName": "国産若鶏ササミスティックカツ",
          "GuideStandardName": "２１０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023280",
          "DelivCatalogId": "20230904",
          "ImageId": "672884",
          "Enabled": "0",
          "ImageName": "P2670388C",
          "ClassCode": "03",
          "ClassName": "畜産",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "09",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "プライフーズ（畜産）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230613",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230531",
          "ImageInstructUserId": "nakamus4",
          "ImageInstructUser": "",
          "BuyerName": "中村清一",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230725 16:45:23",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4974665087484",
          "ImageGroupNo": "576164",
          "SmallClass": "国産若鶏",
          "BuyerCode": "00300005",
          "BillingCode": "921696",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2670388"
        },
        {
          "ImageFileName": "P2671717C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E4729421-N56F3YZR-N56F3YZR",
          "GuideGoodsName": "ミニソフトロール（プレーン）",
          "GuideStandardName": "５個",
          "PhotoContentsName": "",
          "StartOrderCode": "2023290",
          "DelivCatalogId": "20231001",
          "ImageId": "672225",
          "Enabled": "0",
          "ImageName": "P2671717C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "1",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "マルシャン（クルコ用）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230606",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230526",
          "ImageInstructUserId": "nishiym9",
          "ImageInstructUser": "",
          "BuyerName": "にいがた地域",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230614 13:05:23",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4950218019782",
          "ImageGroupNo": "575837",
          "SmallClass": "ロールパン",
          "BuyerCode": "00800005",
          "BillingCode": "977462",
          "SampleOrderingCode": "977462",
          "SampleOrderingName": "マルシャン（クルコ用）",
          "SupplierSalesStaffName": "",
          "PCode": "P2671717"
        },
        {
          "ImageFileName": "P2671718C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E4729421-N5PT0F42-N5PT0F42",
          "GuideGoodsName": "ロールパン",
          "GuideStandardName": "４個",
          "PhotoContentsName": "",
          "StartOrderCode": "2023290",
          "DelivCatalogId": "20231001",
          "ImageId": "672228",
          "Enabled": "0",
          "ImageName": "P2671718C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "マルシャン（クルコ用）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230606",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230526",
          "ImageInstructUserId": "nishiym9",
          "ImageInstructUser": "",
          "BuyerName": "にいがた地域",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230614 13:05:25",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4950218019805",
          "ImageGroupNo": "575839",
          "SmallClass": "ロールパン",
          "BuyerCode": "00800005",
          "BillingCode": "977462",
          "SampleOrderingCode": "977462",
          "SampleOrderingName": "マルシャン（クルコ用）",
          "SupplierSalesStaffName": "",
          "PCode": "P2671718"
        },
        {
          "ImageFileName": "P2671720C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E9607958-N5J40FGB-N5J40FGB",
          "GuideGoodsName": "越のもちどら",
          "GuideStandardName": "２個",
          "PhotoContentsName": "",
          "StartOrderCode": "2023290",
          "DelivCatalogId": "20231001",
          "ImageId": "672231",
          "Enabled": "0",
          "ImageName": "P2671720C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "風見（クルコ用）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230606",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230526",
          "ImageInstructUserId": "nishiym9",
          "ImageInstructUser": "",
          "BuyerName": "にいがた地域",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230821 16:41:25",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4562337792400",
          "ImageGroupNo": "575841",
          "SmallClass": "その他",
          "BuyerCode": "00800005",
          "BillingCode": "976695",
          "SampleOrderingCode": "976695",
          "SampleOrderingName": "風見（クルコ用）",
          "SupplierSalesStaffName": "",
          "PCode": "P2671720"
        },
        {
          "ImageFileName": "P2673867A_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "G9361999-N6IY9H2B-N6IY9H2B",
          "GuideGoodsName": "信州安曇野そば（つゆ付）",
          "GuideStandardName": "２食入（４７２ｇ）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023290",
          "DelivCatalogId": "20231001",
          "ImageId": "683081",
          "Enabled": "0",
          "ImageName": "P2673867A",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "2",
          "ImageUseMethodName": "Mdb画像使用",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "01",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "P2673867A_02,P2673867A_03                          ",
          "PastImageInfo": "過去画像情報サンプル",
          "ImageCaution": "撮影:ラベル面,撮影／外包材と個包装:1234,撮影角度:正面,並べ方:左手前に重ねる,並べ方／横:1234,並べ方／縦:4321",
          "ReferenceImageNum": "1",
          "BillingName": "三菱食品（特殊冷食）",
          "C2pfStatus": "9",
          "DelayFlag": "1",
          "SupplierAnnouncement": "【取引先コメント1】商品サンプル送付時コメント【取引先コメント2】画像コメント2【取引先コメント3】画像コメント3",
          "SupplierInfo": "連絡事項サンプル",
          "StatusRemandReason": "テスト",
          "ImageInfoChange": "変更サンプル",
          "Remarks": "",
          "PhotoSchedule": "20230802",
          "PhotographingChangeSchedule": "20230801",
          "CarriedForward": "繰越サンプル",
          "ImageInstructDate": "20230802",
          "ImageInstructUserId": "test020 ",
          "ImageInstructUser": "テスト サンプル",
          "BuyerName": "酒井",
          "C2pfUpdateDate": "2020/07/22 17:56:27",
          "PeaceUpdateDate": "20230804 11:10:42",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4901776700988",
          "ImageGroupNo": "582152",
          "SmallClass": "麺",
          "BuyerCode": "00800001",
          "BillingCode": "973246",
          "SampleOrderingCode": "973246",
          "SampleOrderingName": "三菱食品（特殊冷食）",
          "SupplierSalesStaffName": "取０３",
          "PCode": "P2673867"
        },
        {
          "ImageFileName": "P2675299C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E6385673-N82BA49Q-N82BA49Q",
          "GuideGoodsName": "かぼちゃとさつまいものポタージュ",
          "GuideStandardName": "１８０ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023290",
          "DelivCatalogId": "20231001",
          "ImageId": "685968",
          "Enabled": "0",
          "ImageName": "P2675299C",
          "ClassCode": "16",
          "ClassName": "惣菜",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "01",
          "TempRangeName": "冷蔵",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "デリア食品（留型）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230829",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230822",
          "ImageInstructUserId": "ishibek ",
          "ImageInstructUser": "",
          "BuyerName": "髙田紗綾",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230822 16:19:52",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4904577111625",
          "ImageGroupNo": "583827",
          "SmallClass": "その他",
          "BuyerCode": "00500025",
          "BillingCode": "983411",
          "SampleOrderingCode": "983411",
          "SampleOrderingName": "デリア食品（留型）",
          "SupplierSalesStaffName": "",
          "PCode": "P2675299"
        },
        {
          "ImageFileName": "P2674333E_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E4584003-N3SB3AXC-N3SB3AXC",
          "GuideGoodsName": "アルカディア",
          "GuideStandardName": "１８０ｇ（４種）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023300",
          "DelivCatalogId": "20231002",
          "ImageId": "683084",
          "Enabled": "0",
          "ImageName": "P2674333E",
          "ClassCode": "05",
          "ClassName": "菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "02",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "1",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "高山（菓子）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230802",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230802",
          "ImageInstructUserId": "isok2   ",
          "ImageInstructUser": "",
          "BuyerName": "木内咲枝",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230804 11:10:45",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4946841040774",
          "ImageGroupNo": "582155",
          "SmallClass": "手土産菓子",
          "BuyerCode": "00500028",
          "BillingCode": "933988",
          "SampleOrderingCode": "933988",
          "SampleOrderingName": "高山（菓子）",
          "SupplierSalesStaffName": "",
          "PCode": "P2674333"
        },
        {
          "ImageFileName": "P2675063C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "C2787420-0U7919NG-N7B91TKH",
          "GuideGoodsName": "国産りんごデニッシュ",
          "GuideStandardName": "５個入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023310",
          "DelivCatalogId": "20231003",
          "ImageId": "685409",
          "Enabled": "0",
          "ImageName": "P2675063C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "03",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "山崎製パン松戸（パン）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230822",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "shindoy4",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230817 13:08:10",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4903110047452",
          "ImageGroupNo": "583533",
          "SmallClass": "袋物・ミニパン",
          "BuyerCode": "00500033",
          "BillingCode": "964727",
          "SampleOrderingCode": "964727",
          "SampleOrderingName": "山崎製パン松戸（パン）",
          "SupplierSalesStaffName": "",
          "PCode": "P2675063"
        },
        {
          "ImageFileName": "P2674404A_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E3217070-N7GDAMJM-N7GDAMJM",
          "GuideGoodsName": "スーパードライ　ドライクリスタル　６缶パック",
          "GuideStandardName": "３５０ｍｌ×６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023310",
          "DelivCatalogId": "20231003",
          "ImageId": "683104",
          "Enabled": "0",
          "ImageName": "P2674404A",
          "ClassCode": "10",
          "ClassName": "酒",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "03",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "＜連合会酒＞三菱食品９７１３６７",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230808",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230802",
          "ImageInstructUserId": "hamanom4",
          "ImageInstructUser": "",
          "BuyerName": "斎藤和夫",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 13:19:30",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4901004060532",
          "ImageGroupNo": "582169",
          "SmallClass": "スタンダード",
          "BuyerCode": "00500027",
          "BillingCode": "981257",
          "SampleOrderingCode": "981257",
          "SampleOrderingName": "＜連合会酒＞三菱食品９７１３６７",
          "SupplierSalesStaffName": "",
          "PCode": "P2674404"
        },
        {
          "ImageFileName": "P2674404A_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E3217070-N7GDAMJM-N7GDAMJM",
          "GuideGoodsName": "スーパードライ　ドライクリスタル　６缶パック",
          "GuideStandardName": "３５０ｍｌ×６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023310",
          "DelivCatalogId": "20231003",
          "ImageId": "683105",
          "Enabled": "0",
          "ImageName": "P2674404A",
          "ClassCode": "10",
          "ClassName": "酒",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "03",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "＜連合会酒＞三菱食品９７１３６７",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230808",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230802",
          "ImageInstructUserId": "hamanom4",
          "ImageInstructUser": "",
          "BuyerName": "斎藤和夫",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 13:19:31",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4901004060532",
          "ImageGroupNo": "582169",
          "SmallClass": "スタンダード",
          "BuyerCode": "00500027",
          "BillingCode": "981257",
          "SampleOrderingCode": "981257",
          "SampleOrderingName": "＜連合会酒＞三菱食品９７１３６７",
          "SupplierSalesStaffName": "",
          "PCode": "P2674404"
        },
        {
          "ImageFileName": "P2674485C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E8464380-N7BU26MT-N7BU26MT",
          "GuideGoodsName": "中村屋の肉まんインドカレーまん",
          "GuideStandardName": "６コ入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "685481",
          "Enabled": "0",
          "ImageName": "P2674485C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "中村屋",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230817",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "nagasawj",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4904110070488",
          "ImageGroupNo": "583585",
          "SmallClass": "その他",
          "BuyerCode": "00500033",
          "BillingCode": "958522",
          "SampleOrderingCode": "958522",
          "SampleOrderingName": "中村屋",
          "SupplierSalesStaffName": "",
          "PCode": "P2674485"
        },
        {
          "ImageFileName": "P2674486C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E8464380-N7BS010A-N7BS010A",
          "GuideGoodsName": "中村屋の肉まん",
          "GuideStandardName": "３コ入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "685472",
          "Enabled": "0",
          "ImageName": "P2674486C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "中村屋",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230817",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "nagasawj",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4904110070150",
          "ImageGroupNo": "583573",
          "SmallClass": "その他",
          "BuyerCode": "00500033",
          "BillingCode": "958522",
          "SampleOrderingCode": "958522",
          "SampleOrderingName": "中村屋",
          "SupplierSalesStaffName": "",
          "PCode": "P2674486"
        },
        {
          "ImageFileName": "P2674487C_01",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E8464380-N7BS2MIQ-N7BS2MIQ",
          "GuideGoodsName": "中村屋のあんまん",
          "GuideStandardName": "３コ入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "685469",
          "Enabled": "0",
          "ImageName": "P2674487C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "中村屋",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230817",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "nagasawj",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4904110070051",
          "ImageGroupNo": "583570",
          "SmallClass": "その他",
          "BuyerCode": "00500033",
          "BillingCode": "958522",
          "SampleOrderingCode": "958522",
          "SampleOrderingName": "中村屋",
          "SupplierSalesStaffName": "",
          "PCode": "P2674487"
        },
        {
          "ImageFileName": "P2674487C_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "E8464380-N7BS2MIQ-N7BS2MIQ",
          "GuideGoodsName": "中村屋のあんまん",
          "GuideStandardName": "３コ入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "685470",
          "Enabled": "0",
          "ImageName": "P2674487C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "中村屋",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230817",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "nagasawj",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4904110070051",
          "ImageGroupNo": "583571",
          "SmallClass": "その他",
          "BuyerCode": "00500033",
          "BillingCode": "958522",
          "SampleOrderingCode": "958522",
          "SampleOrderingName": "中村屋",
          "SupplierSalesStaffName": "",
          "PCode": "P2674487"
        },
        {
          "ImageFileName": "P2675069C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E4237588-N7B935WO-N7B935WO",
          "GuideGoodsName": "しっとりチーズ蒸しケーキ",
          "GuideStandardName": "４個入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "685412",
          "Enabled": "0",
          "ImageName": "P2675069C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "山崎製パン松戸（パン）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230822",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "shindoy4",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230817 13:16:09",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4903110510246",
          "ImageGroupNo": "583535",
          "SmallClass": "袋物・ミニパン",
          "BuyerCode": "00500033",
          "BillingCode": "964727",
          "SampleOrderingCode": "964727",
          "SampleOrderingName": "山崎製パン松戸（パン）",
          "SupplierSalesStaffName": "",
          "PCode": "P2675069"
        },
        {
          "ImageFileName": "P2675070C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E4237588-N7B93242-N7B93242",
          "GuideGoodsName": "もちもちとしたよもぎ蒸しパン",
          "GuideStandardName": "４個入",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "685415",
          "Enabled": "0",
          "ImageName": "P2675070C",
          "ClassCode": "09",
          "ClassName": "パン生菓子",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "山崎製パン松戸（パン）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230822",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "shindoy4",
          "ImageInstructUser": "",
          "BuyerName": "宮崎治彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230817 13:20:33",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4903110511854",
          "ImageGroupNo": "583537",
          "SmallClass": "袋物・ミニパン",
          "BuyerCode": "00500033",
          "BillingCode": "964727",
          "SampleOrderingCode": "964727",
          "SampleOrderingName": "山崎製パン松戸（パン）",
          "SupplierSalesStaffName": "",
          "PCode": "P2675070"
        },
        {
          "ImageFileName": "P2674382A_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E8680772-N76XCM6O-N76XCM6O",
          "GuideGoodsName": "サッポロ生ビール　ナナマル　６缶パック",
          "GuideStandardName": "３５０ｍｌ×６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "683089",
          "Enabled": "0",
          "ImageName": "P2674382A",
          "ClassCode": "10",
          "ClassName": "酒",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "＜連合会酒＞国分首都圏９７１３５９",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230811",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230802",
          "ImageInstructUserId": "hamanom4",
          "ImageInstructUser": "",
          "BuyerName": "斎藤和夫",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230808 10:30:04",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4901880209674",
          "ImageGroupNo": "582503",
          "SmallClass": "スタンダード",
          "BuyerCode": "00500027",
          "BillingCode": "981249",
          "SampleOrderingCode": "981249",
          "SampleOrderingName": "＜連合会酒＞国分首都圏９７１３５９",
          "SupplierSalesStaffName": "",
          "PCode": "P2674382"
        },
        {
          "ImageFileName": "P2674382A_02",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E8680772-N76XCM6O-N76XCM6O",
          "GuideGoodsName": "サッポロ生ビール　ナナマル　６缶パック",
          "GuideStandardName": "３５０ｍｌ×６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "683090",
          "Enabled": "0",
          "ImageName": "P2674382A",
          "ClassCode": "10",
          "ClassName": "酒",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "＜連合会酒＞国分首都圏９７１３５９",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230811",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230802",
          "ImageInstructUserId": "hamanom4",
          "ImageInstructUser": "",
          "BuyerName": "斎藤和夫",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230808 10:30:21",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4901880209674",
          "ImageGroupNo": "582504",
          "SmallClass": "スタンダード",
          "BuyerCode": "00500027",
          "BillingCode": "981249",
          "SampleOrderingCode": "981249",
          "SampleOrderingName": "＜連合会酒＞国分首都圏９７１３５９",
          "SupplierSalesStaffName": "",
          "PCode": "P2674382"
        },
        {
          "ImageFileName": "P2674382C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E8680772-N76XCM6O-N76XCM6O",
          "GuideGoodsName": "サッポロ生ビール　ナナマル　６缶パック",
          "GuideStandardName": "３５０ｍｌ×６",
          "PhotoContentsName": "",
          "StartOrderCode": "2023320",
          "DelivCatalogId": "20231004",
          "ImageId": "683091",
          "Enabled": "0",
          "ImageName": "P2674382C",
          "ClassCode": "10",
          "ClassName": "酒",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "10",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "＜連合会酒＞国分首都圏９７１３５９",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230811",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230802",
          "ImageInstructUserId": "hamanom4",
          "ImageInstructUser": "",
          "BuyerName": "斎藤和夫",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230808 10:30:39",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4901880209674",
          "ImageGroupNo": "582160",
          "SmallClass": "スタンダード",
          "BuyerCode": "00500027",
          "BillingCode": "981249",
          "SampleOrderingCode": "981249",
          "SampleOrderingName": "＜連合会酒＞国分首都圏９７１３５９",
          "SupplierSalesStaffName": "",
          "PCode": "P2674382"
        },
        {
          "ImageFileName": "P2662647C_02",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "C5245734-MP1M130N-MP1M130N",
          "GuideGoodsName": "もぐもぐ工房のクリスマスブーツ",
          "GuideStandardName": "６品",
          "PhotoContentsName": "",
          "StartOrderCode": "2023360",
          "DelivCatalogId": "20231104",
          "ImageId": "682846",
          "Enabled": "0",
          "ImageName": "P2662647C",
          "ClassCode": "06",
          "ClassName": "食品",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "11",
          "DelivCatalogTime": "04",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "1",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "",
          "TempRangeName": "",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "三菱食品（菓子）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230822",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230801",
          "ImageInstructUserId": "itouk46 ",
          "ImageInstructUser": "",
          "BuyerName": "斎藤健二",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230801 16:25:46",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4560270402127",
          "ImageGroupNo": "582016",
          "SmallClass": "その他",
          "BuyerCode": "00600019",
          "BillingCode": "963186",
          "SampleOrderingCode": "963186",
          "SampleOrderingName": "三菱食品（菓子）",
          "SupplierSalesStaffName": "",
          "PCode": "P2662647"
        },
        {
          "ImageFileName": "P2674719C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "F2157159-N7NC015F-N7NC015F",
          "GuideGoodsName": "北海道産塩紅鮭切身（甘口）",
          "GuideStandardName": "１６０ｇ（２切）",
          "PhotoContentsName": "調理イメージ",
          "StartOrderCode": "2023370",
          "DelivCatalogId": "20231105",
          "ImageId": "684258",
          "Enabled": "0",
          "ImageName": "P2674719C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "11",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "北海道漁連（水産）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230818",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230809",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "百田厚彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230811 10:52:14",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4968295443642",
          "ImageGroupNo": "582857",
          "SmallClass": "惣菜魚２ぐるめぐり",
          "BuyerCode": "00200006",
          "BillingCode": "941069",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2674719"
        },
        {
          "ImageFileName": "P2674721C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "F2157159-N7NC3VQC-N7NC3VQC",
          "GuideGoodsName": "北海道利尻礼文産真ほっけ開き（特大）",
          "GuideStandardName": "８００ｇ（２枚）",
          "PhotoContentsName": "調理イメージ",
          "StartOrderCode": "2023370",
          "DelivCatalogId": "20231105",
          "ImageId": "684261",
          "Enabled": "0",
          "ImageName": "P2674721C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "11",
          "DelivCatalogTime": "05",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "北海道漁連（水産）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230818",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230809",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "百田厚彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4968295447206",
          "ImageGroupNo": "582860",
          "SmallClass": "惣菜魚２ぐるめぐり",
          "BuyerCode": "00200006",
          "BillingCode": "941069",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2674721"
        },
        {
          "ImageFileName": "P2674984C_01",
          "Status": "1",
          "StatusName": "ファイル登録待ち",
          "EbaseSpecCode": "E2456372-MDV33TJM-N6UY3BLP",
          "GuideGoodsName": "社長のいか塩辛　極",
          "GuideStandardName": "２００ｇ",
          "PhotoContentsName": "",
          "StartOrderCode": "2023380",
          "DelivCatalogId": "20231201",
          "ImageId": "685267",
          "Enabled": "0",
          "ImageName": "P2674984C",
          "ClassCode": "02",
          "ClassName": "水産",
          "C2pfTarget": "0",
          "ImageKind": "1",
          "ImageKindName": "撮影",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "12",
          "DelivCatalogTime": "01",
          "Packaging": "",
          "Plating": "",
          "CookNecessary": "1",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "北海道漁連（水産）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230825",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230817",
          "ImageInstructUserId": "momotaa ",
          "ImageInstructUser": "",
          "BuyerName": "百田厚彦",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "",
          "PrintDate": "",
          "PhotoStudio": "東銀座印刷",
          "JanCode": "4976132024299",
          "ImageGroupNo": "583450",
          "SmallClass": "刺身生食ぐるめぐり",
          "BuyerCode": "00200006",
          "BillingCode": "941069",
          "SampleOrderingCode": "947164",
          "SampleOrderingName": "ロジネット入間物流",
          "SupplierSalesStaffName": "",
          "PCode": "P2674984"
        },
        {
          "ImageFileName": "P2663546A_02",
          "Status": "2",
          "StatusName": "画像登録済み",
          "EbaseSpecCode": "G9361999-MNEZ94GV-N16F7EQP",
          "GuideGoodsName": "上生菓子（６種）",
          "GuideStandardName": "２３０ｇ（６種×各１個）",
          "PhotoContentsName": "",
          "StartOrderCode": "2023410",
          "DelivCatalogId": "20231204",
          "ImageId": "681840",
          "Enabled": "0",
          "ImageName": "P2663546A",
          "ClassCode": "15",
          "ClassName": "冷食・アイス",
          "C2pfTarget": "0",
          "ImageKind": "3",
          "ImageKindName": "メーカーデータ",
          "ImageUseMethod": "",
          "ImageUseMethodName": "",
          "PhotographingNo": "",
          "DelivCatalogMonth": "12",
          "DelivCatalogTime": "04",
          "Packaging": "1",
          "Plating": "",
          "CookNecessary": "",
          "CookUnnecessary": "",
          "Explain": "",
          "Other": "",
          "BackSide": "",
          "TempRange": "00",
          "TempRangeName": "冷凍",
          "MultipleCode": "",
          "PastImageInfo": "",
          "ImageCaution": "",
          "ReferenceImageNum": "0",
          "BillingName": "三菱食品（冷食）",
          "C2pfStatus": "",
          "DelayFlag": "",
          "SupplierAnnouncement": "",
          "SupplierInfo": "",
          "StatusRemandReason": "",
          "ImageInfoChange": "",
          "Remarks": "",
          "PhotoSchedule": "20230801",
          "PhotographingChangeSchedule": "",
          "CarriedForward": "",
          "ImageInstructDate": "20230725",
          "ImageInstructUserId": "araik30 ",
          "ImageInstructUser": "",
          "BuyerName": "新井加菜子",
          "C2pfUpdateDate": "",
          "PeaceUpdateDate": "20230816 13:16:56",
          "PrintDate": "",
          "PhotoStudio": "凸版印刷",
          "JanCode": "4520615400508",
          "ImageGroupNo": "581354",
          "SmallClass": "和風スナック",
          "BuyerCode": "00500029",
          "BillingCode": "973254",
          "SampleOrderingCode": "973254",
          "SampleOrderingName": "三菱食品（冷食）",
          "SupplierSalesStaffName": "",
          "PCode": "P2663546"
        }
      ]
    }
  }
};

const KYMW17GetSampleOrderingOutputResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      FileUrl: 'http://127.0.0.1:8083/N_PEACE/file/image/UnRegistImage.png'
    }
  }
};

const KYMW17UpdateImageInfoResponse = {
  status: 'ok',
  message: '処理完了',
  result: {
    obj: {
      updateImageInfo: [
        {
          PhotoContentNum: '1',
          ResultCode: '0',
          ErrorContent: ''
        },
        {
          PhotoContentNum: '2',
          ResultCode: '0',
          ErrorContent: '更新中にエラーが発生しました。'
        },
        {
          PhotoContentNum: '3',
          ResultCode: '1',
          ErrorContent: '更新中にエラーが発生しました。'
        }
      ]
    }
  }
};
